import React from 'react'

export default ({ serviceTxn = {} }) => {
  switch (serviceTxn.checkInType) {
    case 'airline':
      return (
        <div>
          <h5>Airline</h5>
          <h5>
            <b>{serviceTxn.airlineCheckInInfo.airline.name}</b>
          </h5>
        </div>
      )
    case 'agent':
      return (
        <div>
          <h5>Agent</h5>
          <h5>
            <b>{serviceTxn.agentCheckInInfo.agent.name}</b>
          </h5>
        </div>
      )
    case 'walkin': {
      const walkinType = serviceTxn.walkinCheckInInfo.type
      if (walkinType === 'cash') return <div>Cash</div>
      if (walkinType === 'card')
        return renderCard(serviceTxn.walkinCheckInInfo.card)
      if (walkinType === 'creditCard') return <div>Credit Card</div>
      return <div>{walkinType}</div>
    }
    default:
      return null
  }
}

const renderCard = (card) => (
  <div>
    <h5>Card</h5>
    <h5>
      <b>
        {card.name} - {card.privilegeClass}
      </b>
    </h5>
  </div>
)
